module.exports = "/_next/static/images/play_store_badge-b745267fdada56be06e1f1651c7d2ade.svg";